/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsNetworkV1: {
  name: 'network-v1';
  data: string;
} = {
  name: 'network-v1',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2v7a2 2 0 0 0 2 2h4v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2V7a2 2 0 0 0-2-2h-4V4a2 2 0 0 0-2-2H4Zm8 15H8v-7h2a2 2 0 0 0 2-2V7h4v7h-2a2 2 0 0 0-2 2v1Zm2 1v2h6v-4h-6v2ZM7 8h3V4H4v4h3Z" fill="currentColor"/></svg>`,
};
